import styles from './record.module.css';

/** Kontaktakte I.12 „Ladend": the head placeholder and three 460 px cards in the record's own geometry. */
export function RecordSkeleton() {
  return (
    <div className={styles.stack} aria-busy="true" aria-label="Wird geladen">
      <div className={styles.skeletonHead}>
        <div className={styles.skeletonCircle} />
        <div>
          <div className={styles.skeletonBar} />
          <div className={styles.skeletonBarThin} />
        </div>
      </div>
      <div className={styles.grid}>
        <div className={styles.skeletonCard} />
        <div className={styles.skeletonCard} />
        <div className={`${styles.skeletonCard} ${styles.columnRight}`} />
      </div>
      <p className={styles.skeletonText}>
        Gerüst statt Spinner: die Akte hat immer dieselben drei Spalten, deshalb steht das Layout schon vor
        den Daten.
      </p>
    </div>
  );
}
